import React from "react";
import * as THREE from "three";
import OBJLoader from "three-obj-loader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import Switch from './Switch';
import IconButton from './IconButton';
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Button from 'react-bootstrap/Button'
import { formatURL } from '../utils/utils'

OBJLoader(THREE);

function dumpObject(obj, lines = [], isLast = true, prefix = "") {
  const localPrefix = isLast ? "└─" : "├─";
  // if (obj.material !== undefined) lines.push(`${prefix}${prefix ? localPrefix : ""}${obj.name || "*no-name*"} [${obj.type}] [${obj.material.name || "*no-material"}] [${obj.material.color.r} ${obj.material.color.g} ${obj.material.color.b}] [${obj.material.visible ? "visible" : "invisible"}]`);
  if (obj.material !== undefined) lines.push(`${prefix}${prefix ? localPrefix : ""} ${obj.name || "*no-name*"}`);
  else lines.push(`${prefix}${prefix ? localPrefix : ""} ${obj.name || "*no-name*"} [${obj.type}]`);
  const newPrefix = prefix + (isLast ? "  " : "│ ");
  const lastNdx = obj.children.length - 1;
  obj.children.forEach((child, ndx) => {
    const isLast = ndx === lastNdx;
    dumpObject(child, lines, isLast, newPrefix);
  });
  return lines;
}

export default class THREEScene extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      innerMaterial: null,
      outerMaterial: null,
      activeModuleData: null,
      activeModule: null,
      slots: null,
      hasDoors: false,
      doorToggle: false,
      activeGrip: { feature_id: -1 },
      activeGripData: { feature_id: -1 },
      cameraAngle: "left",
    };
    this.currentRoomDim = {
      B: this.props.boxDimensions.B,
      H: this.props.boxDimensions.H,
      D: this.props.boxDimensions.D,
      AL: this.props.boxDimensions.AL,
      AR: this.props.boxDimensions.AR,
      PB: this.props.boxDimensions.PB,
      PO: this.props.boxDimensions.PO,
    };
    this.GLTFLoader = new GLTFLoader();
  }
  componentDidMount() {
    // Conversion Width (Conversion Rate to get height using width) -> height: 9/16 = 0.5625 (16:9 resolution)
    const container = document.getElementById("renderer-container");
    const containerWidth = container.offsetWidth;
    const containerHeight = containerWidth * 0.5625;
    container.style.height = containerHeight + "px"; //set height of container (this is for the buttons in the sidebar to be able to line up to the bottom of this container)

    this.canvasWidth = containerWidth;
    this.canvasHeight = containerHeight;

    this.slotWidth = 60.1;

    this.closetWidth = this.props.boxDimensions.B / 100.0;
    this.closetHeight = this.props.boxDimensions.H / 100.0;
    this.closetDepth = this.props.boxDimensions.D / 100.0;
    // this.floorHeight = 4;
    this.floorHeight = 0;

    this.cameraHeight = 1.10;
    this.cameraDist = 3;
    this.slotCount = getSlotCount(this.props.boxDimensions, this.slotWidth);

    this.placedmodels = [];
    this.outerObjects = [];

    this.raycaster = new THREE.Raycaster();
    this.mouse = new THREE.Vector2();

    this.THREE = THREE;
    this.selectedModel = null;

    this.setUpScene();

    this.start();
    this.init = true;
    this.updateScene();

    window.addEventListener("resize", this._handleResize);
  }

  componentDidUpdate() {
    if (this.init) {
      this.updateScene();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this._handleResize);
    this.stop();
    this.mount.removeChild(this.renderer.domElement);
    this.init = false;
  }

  _handleResize = () => {
    // Conversion Width (Conversion Rate to get height using width) -> height: 9/16 = 0.5625 (16:9 resolution)

    setTimeout(() => {
      //Timeout required, because due to mediaqueries changing the CSS, this function is sometimes too fast to use the new CSS sizes
      const container = document.getElementById("renderer-container");
      const containerWidth = container.offsetWidth;
      const containerHeight = containerWidth * 0.5625;
      container.style.height = containerHeight + "px"; //set height of container (this is for the buttons in the sidebar to be able to line up to the bottom of this container)

      const cameraButtons = document.getElementById("renderer-camera-buttons");
      cameraButtons.style.marginTop = (containerHeight - 140) + "px";

      // const sidePanelActions = document.getElementById("side-panel-actions");
      // sidePanelActions.style.marginTop = containerHeight + "px";

      this.canvasWidth = containerWidth;
      this.canvasHeight = containerHeight;

      this.renderer.setSize(containerWidth, containerHeight);
    }, 500);
  };

  setUpScene = () => {
    this.scene = new THREE.Scene();

    this.scene.background = new THREE.Color("lightgrey");

    this.camera = new THREE.PerspectiveCamera(60, this.canvasWidth / this.canvasHeight, 0.1, 1000);
    this.setCameraAngle("center");

    this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    //this.renderer.setClearColor("#000000");
    this.renderer.setSize(this.canvasWidth, this.canvasHeight);
    this.renderer.outputEncoding = THREE.sRGBEncoding;

    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = THREE.PCFShadowMap;

    this.mount.appendChild(this.renderer.domElement);

    // Lighting

    const color = 0xffffff;
    const intensity = .35;

    this.light1 = new THREE.SpotLight(color, intensity);
    this.light2 = new THREE.SpotLight(color, intensity);
    this.light3 = new THREE.SpotLight(color, .5);

    // this.scene.add(new THREE.AmbientLight(color, .3))

    this.light1.position.set(this.closetWidth, this.closetHeight * 1.3, 3.5)
    this.light2.position.set(this.closetWidth, this.closetHeight * 1.3, 3.5)
    this.light3.position.set(0, this.closetHeight * 1.3, 3.5)


    let geometry = new THREE.BoxGeometry(0.01, 0.01, 0.01);
    let material = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
    this.target = new THREE.Mesh(geometry, material);
    this.target.visible = false;
    this.target.position.set(this.closetWidth / 2, 1, 0)

    this.scene.add(this.target)

    this.light1.target = this.target;
    this.light2.target = this.target;
    this.light3.target = this.target;

    this.light1.castShadow = true;
    this.light1.shadow = new THREE.SpotLightShadow(new THREE.PerspectiveCamera(50, 1, 10, 2500))

    this.light1.shadow.mapSize.width = 1024 * 4;  // default
    this.light1.shadow.mapSize.height = 1024 * 4; // default
    this.light1.shadow.camera.near = 0.5;       // default
    this.light1.shadow.camera.far = 500      // default

    this.scene.add(this.light1)
    this.scene.add(this.light2)
    this.scene.add(this.light3)

    // var targetObject = new THREE.Object3D();
    // targetObject.position.set(0, 0, -1)
    // this.scene.add(targetObject);

    // let geometry3 = new THREE.BoxGeometry(0.1, 0.1, 0.1);
    // let material = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
    // this.origin = new THREE.Mesh(geometry3, material);
    // this.scene.add(this.origin);

    this.addBox(this.closetWidth, this.closetHeight, this.closetDepth);
    this.addRoom(this.currentRoomDim);
    this.addPlaceholder(this.currentRoomDim);
    this.drawSlotLines(this.currentRoomDim, this.cameraDist, this.slotCount);
    this.createSlotBoxes(this.currentRoomDim, this.slotCount);

  }

  resetScene = () => {
    this.setCameraAngle("center");

    this.slotCount = getSlotCount(this.props.boxDimensions, this.slotWidth);

    const color = 0xffffff;
    const intensity = .35;

    this.light1 = new THREE.SpotLight(color, intensity);
    this.light2 = new THREE.SpotLight(color, intensity);
    this.light3 = new THREE.SpotLight(color, .5);

    this.light1.position.set(this.closetWidth, this.closetHeight * 1.3, 3.5)
    this.light2.position.set(this.closetWidth, this.closetHeight * 1.3, 3.5)
    this.light3.position.set(0, this.closetHeight * 1.3, 3.5)


    let trgt_geometry = new THREE.BoxGeometry(0.01, 0.01, 0.01);
    let trgt_material = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
    this.target = new THREE.Mesh(trgt_geometry, trgt_material);
    this.target.visible = false;
    this.target.position.set(this.closetWidth / 2, 1, 0)

    this.scene.add(this.target)

    this.light1.target = this.target;
    this.light2.target = this.target;
    this.light3.target = this.target;

    this.light1.castShadow = true;
    this.light1.shadow = new THREE.SpotLightShadow(new THREE.PerspectiveCamera(50, 1, 10, 2500))

    this.light1.shadow.mapSize.width = 1024 * 4;  // default
    this.light1.shadow.mapSize.height = 1024 * 4; // default
    this.light1.shadow.camera.near = 0.5;       // default
    this.light1.shadow.camera.far = 500      // default

    this.scene.add(this.light1)
    this.scene.add(this.light2)
    this.scene.add(this.light3)


    // let org_geometry = new THREE.BoxGeometry(0.1, 0.1, 0.1);
    // let org_material = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
    // this.origin = new THREE.Mesh(org_geometry, org_material);
    //this.scene.add(this.origin);

    this.addBox(this.closetWidth, this.closetHeight, this.closetDepth);
    this.addRoom(this.currentRoomDim);
    this.addPlaceholder(this.currentRoomDim);
    this.drawSlotLines(this.currentRoomDim, this.cameraDist, this.slotCount);
    this.createSlotBoxes(this.currentRoomDim, this.slotCount);

  };

  setCameraAngle = angle => {

    let cameraOffset = this.cameraDist * Math.tan(20 * Math.PI / 180)

    switch (angle) {
      case "center":
        this.camera.position.set(this.closetWidth / 2.0, this.cameraHeight, this.cameraDist);
        this.camera.lookAt(this.closetWidth / 2.0, this.cameraHeight, 0);
        break;
      case "left":
        this.camera.position.set(this.closetWidth / 2.0 - cameraOffset, this.cameraHeight, this.cameraDist);
        this.camera.lookAt(this.closetWidth / 2.0, this.cameraHeight, 0);
        break;
      case "right":
        this.camera.position.set(this.closetWidth / 2.0 + cameraOffset, this.cameraHeight, this.cameraDist);
        this.camera.lookAt(this.closetWidth / 2.0, this.cameraHeight, 0);
        break;
    }

    this.setState({ cameraAngle: angle })

  }

  createSlotBoxes = (dimensions, slotCount) => {
    const colors = ["#ff0000", "#00ff00", "#0000ff"];
    let slots = [];
    for (let slotID = 0; slotID < slotCount; slotID++) {
      let innerWidth = (dimensions.B - dimensions.AL - dimensions.AR) / 100.0;
      let innerHeight = (dimensions.H - dimensions.PO - dimensions.PB) / 100.0;
      let geometry = new THREE.BoxGeometry(innerWidth / slotCount - 0.05, innerHeight - 0.05, dimensions.D / 100.0 - 0.05);
      let material = new THREE.MeshPhongMaterial({
        color: colors[1],
        visible: false,
        opacity: 0.5,
        transparent: true,
      });
      // material.visible = false; // Make sure the boxes are invisible to the user while still interacting with the raycast.
      let box = new THREE.Mesh(geometry, material);
      box.position.set((innerWidth / slotCount) * slotID + innerWidth / slotCount / 2 + dimensions.AL / 100.0, innerHeight / 2 + dimensions.PO / 100.0, -dimensions.D / 100.0 / 2);

      box.name = "Cslot " + slotID;
      this.scene.add(box);
      slots.push({
        slotObj: box,
        isFilled: false,
        module: null,
      })
    }
    this.setState({
      slots: slots
    })
    this.props.updateSlots(slots)
    this.props.updatePrice(slots)
  };

  drawSlotLines = (dimensions, cameraDist, slotCount) => {
    let materialDark = new THREE.LineDashedMaterial({
      color: 0x0000ff,
      scale: 1.5,
      dashSize: 0.2,
      gapSize: 0.2,
    });

    let materialLight = new THREE.LineDashedMaterial({
      color: 0x00f0ff,
      scale: 1.5,
      dashSize: 0.2,
      gapSize: 0.2,
    });

    //console.log(boxWidth, slotCount)
    for (let slotID = 0; slotID <= slotCount; slotID++) {
      let material = slotID % 2 == 0 ? materialDark : materialLight;
      let geometry = new THREE.Geometry();
      let innerWidth = dimensions.B - dimensions.AL - dimensions.AR;
      let boxX = ((slotID * innerWidth) / slotCount + dimensions.AL) / 100.0;
      geometry.vertices.push(new THREE.Vector3(boxX, dimensions.PO / 100.0, cameraDist));
      geometry.vertices.push(new THREE.Vector3(boxX, dimensions.PO / 100.0, 0));
      let line = new THREE.Line(geometry, material);
      line.computeLineDistances();
      this.scene.add(line);
    }
  };

  addBox = (boxWidth, boxHeight, boxDepth) => {
    //const boxX = boxWidth / 2.0;
    let material = new THREE.LineBasicMaterial({ color: 0xffffff });
    const geometry = new THREE.Geometry();
    // geometry.vertices.push(new THREE.Vector3(-10, 0, 0));
    // geometry.vertices.push(new THREE.Vector3(0, 10, 0));
    // geometry.vertices.push(new THREE.Vector3(10, 0, 0));
    geometry.vertices.push(new THREE.Vector3(0, 0, 0));
    geometry.vertices.push(new THREE.Vector3(0, 0, 20));
    geometry.vertices.push(new THREE.Vector3(0, 0, 0));
    geometry.vertices.push(new THREE.Vector3(boxWidth, 0, 0));
    geometry.vertices.push(new THREE.Vector3(boxWidth, 0, 20));
    geometry.vertices.push(new THREE.Vector3(boxWidth, 0, 0));
    geometry.vertices.push(new THREE.Vector3(boxWidth, boxHeight, 0));
    geometry.vertices.push(new THREE.Vector3(boxWidth, boxHeight, 20));
    geometry.vertices.push(new THREE.Vector3(boxWidth, boxHeight, 0));
    geometry.vertices.push(new THREE.Vector3(0, boxHeight, 0));
    geometry.vertices.push(new THREE.Vector3(0, boxHeight, 20));
    geometry.vertices.push(new THREE.Vector3(0, boxHeight, 0));
    geometry.vertices.push(new THREE.Vector3(0, 0, 0));
    geometry.vertices.push(new THREE.Vector3(0, 0, -boxDepth));
    geometry.vertices.push(new THREE.Vector3(boxWidth, 0, -boxDepth));
    geometry.vertices.push(new THREE.Vector3(boxWidth, 0, 0));
    geometry.vertices.push(new THREE.Vector3(boxWidth, 0, -boxDepth));
    geometry.vertices.push(new THREE.Vector3(boxWidth, boxHeight, -boxDepth));
    geometry.vertices.push(new THREE.Vector3(boxWidth, boxHeight, 0));
    geometry.vertices.push(new THREE.Vector3(boxWidth, boxHeight, -boxDepth));
    geometry.vertices.push(new THREE.Vector3(0, boxHeight, -boxDepth));
    geometry.vertices.push(new THREE.Vector3(0, boxHeight, 0));
    geometry.vertices.push(new THREE.Vector3(0, boxHeight, -boxDepth));
    geometry.vertices.push(new THREE.Vector3(0, 0, -boxDepth));

    let line = new THREE.Line(geometry, material);

    this.scene.add(line);

  };

  addRoom = (roomDim) => {

    let texloader = new THREE.TextureLoader();
    var map = texloader.load(formatURL("assets/textures/floor.png"));

    map.wrapS = map.wrapT = THREE.RepeatWrapping;
    map.repeat.set(25, 10);

    let roomType = this.props.room.room_type;

    let roomHeight = roomDim.H / 100.0;
    let roomWidth = roomDim.B / 100.0;
    let roomDepth = roomDim.D / 100.0

    if (!roomType.includes("Plafond")) {
      roomHeight = 4
    }

    this.wallMaterial = new THREE.MeshPhongMaterial({ color: this.props.wallColor/*, visible: false*/ });
    let floorMaterial = new THREE.MeshPhongMaterial({ map: map/*, visible: false*/ });
    let ceilingMaterial = new THREE.MeshPhongMaterial({ color: 0xffffff/*, visible: false*/ });

    let wallLeftGeometry = new THREE.BoxGeometry(.5, roomHeight, this.cameraDist * 2);
    let wallLeft = new THREE.Mesh(wallLeftGeometry, this.wallMaterial);
    wallLeft.position.set(-0.25, roomHeight / 2, this.cameraDist - roomDepth)
    wallLeft.name = "wall - left"

    let wallRightGeometry = new THREE.BoxGeometry(.5, roomHeight, this.cameraDist * 2);
    let wallRight = new THREE.Mesh(wallRightGeometry, this.wallMaterial);
    wallRight.position.set(roomWidth + .25, roomHeight / 2, this.cameraDist - roomDim.D / 100.0)
    wallRight.name = "wall - right"

    let wallBackGeometry = new THREE.BoxGeometry(25, roomHeight, .5);
    let wallBack = new THREE.Mesh(wallBackGeometry, this.wallMaterial);
    wallBack.position.set(roomWidth / 2, roomHeight / 2, -roomDim.D / 100.0 - .25)
    wallBack.name = "wall - back"

    let floorGeometry = new THREE.BoxGeometry(25, .5, this.cameraDist * 4);
    let floor = new THREE.Mesh(floorGeometry, floorMaterial);
    floor.position.set(roomWidth / 2, -.25, this.cameraDist)
    this.scene.add(floor)

    let ceilingGeometry = new THREE.BoxGeometry(roomWidth * 5, .5, this.cameraDist * 4);
    let ceiling = new THREE.Mesh(ceilingGeometry, ceilingMaterial);
    ceiling.position.set(roomWidth / 2, roomHeight + .25, this.cameraDist)

    // Configure Room finishes according to Room_type
    switch (this.props.room.room_type) {
      case "Alleenstaand":
        this.scene.add(wallBack);
        break;
      case "Alleenstaand Plafond":
        this.scene.add(wallBack);
        // this.scene.add(ceiling)
        break;
      case "Links open":
        this.scene.add(wallBack);
        this.scene.add(wallRight);
        break;
      case "Links open Plafond":
        this.scene.add(wallBack);
        this.scene.add(wallRight);
        // this.scene.add(ceiling)
        break;
      case "Rechts open":
        this.scene.add(wallBack);
        this.scene.add(wallLeft);
        break;
      case "Rechts open Plafond":
        this.scene.add(wallBack);
        this.scene.add(wallLeft);
        // this.scene.add(ceiling)
        break;
      case "Ingebouwd":
        this.scene.add(wallBack);
        this.scene.add(wallLeft);
        this.scene.add(wallRight);
        break;
      case "Ingebouwd Plafond":
        this.scene.add(wallBack);
        this.scene.add(wallLeft);
        this.scene.add(wallRight);
        // this.scene.add(ceiling)
        break;
      default:
        console.log("Invalid RoomType :: " + this.props.room_type)

    }
  }

  addPlaceholder = (roomDim) => {
    let material = new THREE.MeshPhongMaterial({ color: 0xffffff });

    const floorGeometry = new THREE.BoxGeometry(roomDim.B / 100.0, roomDim.PO / 100.0, roomDim.D / 100.0);
    let floor = new THREE.Mesh(floorGeometry, material);
    floor.position.set(roomDim.B / 2 / 100.0, roomDim.PO / 2 / 100.0, -roomDim.D / 2 / 100.0);
    this.scene.add(floor);
    this.outerObjects.push(floor);
    floor.receiveShadow = true;

    const verticalLeftBarGeometry = new THREE.BoxGeometry(roomDim.AL / 100.0, roomDim.H / 100.0, 0.1);
    let leftBar = new THREE.Mesh(verticalLeftBarGeometry, material);
    leftBar.position.set(roomDim.AL / 2 / 100.0, roomDim.H / 2 / 100.0, -0.05);
    leftBar.castShadow = true;

    const verticalRightBarGeometry = new THREE.BoxGeometry(roomDim.AR / 100.0, roomDim.H / 100.0, 0.1);
    let rightBar = new THREE.Mesh(verticalRightBarGeometry, material);
    rightBar.position.set((roomDim.B - roomDim.AR / 2) / 100.0, roomDim.H / 2 / 100.0, -0.05);
    rightBar.castShadow = true;

    const topGeometry = new THREE.BoxGeometry(roomDim.B / 100.0, roomDim.PB / 100.0, 0.1);
    let topBar = new THREE.Mesh(topGeometry, material);
    topBar.position.set(roomDim.B / 2 / 100.0, (roomDim.H - roomDim.PB / 2) / 100.0, -0.05);
    topBar.castShadow = true;

    const ceilingGeometry = new THREE.BoxGeometry(roomDim.B / 100.0, roomDim.PB / 100.0, roomDim.D / 100.0);
    let topPlate = new THREE.Mesh(ceilingGeometry, material);
    topPlate.position.set(roomDim.B / 2 / 100.0, (roomDim.H - roomDim.PB / 2) / 100.0, -roomDim.D / 2 / 100.0);
    topPlate.castShadow = true;

    const verticalLeftSideGeometry = new THREE.BoxGeometry(roomDim.AL / 100.0, roomDim.H / 100.0, roomDim.D / 100.0);
    let leftSide = new THREE.Mesh(verticalLeftSideGeometry, material);
    leftSide.position.set(roomDim.AL / 2 / 100.0, roomDim.H / 2 / 100.0, -roomDim.D / 100.0 / 2);
    leftSide.castShadow = true;

    const verticalRightSideGeometry = new THREE.BoxGeometry(roomDim.AR / 100.0, roomDim.H / 100.0, roomDim.D / 100.0);
    let rightSide = new THREE.Mesh(verticalRightSideGeometry, material);
    rightSide.position.set((roomDim.B - roomDim.AR / 2) / 100.0, roomDim.H / 2 / 100.0, -roomDim.D / 100.0 / 2);
    rightSide.castShadow = true;


    // Configure Room finishes according to Room_type
    // console.log(this.props)
    switch (this.props.room.room_type) {
      case "Alleenstaand":
        this.scene.add(rightSide);
        this.outerObjects.push(rightSide);
        this.scene.add(leftSide);
        this.outerObjects.push(leftSide);
        this.scene.add(topPlate);
        this.outerObjects.push(topPlate);
        break;
      case "Alleenstaand Plafond":
        this.scene.add(rightSide);
        this.outerObjects.push(rightSide);
        this.scene.add(leftSide);
        this.outerObjects.push(leftSide);
        this.scene.add(topBar);
        this.outerObjects.push(topBar);
        break;
      case "Links open":
        this.scene.add(rightBar);
        this.outerObjects.push(rightBar);
        this.scene.add(leftSide);
        this.outerObjects.push(leftSide);
        this.scene.add(topPlate);
        this.outerObjects.push(topPlate);
        break;
      case "Links open Plafond":
        this.scene.add(rightBar);
        this.outerObjects.push(rightBar);
        this.scene.add(leftSide);
        this.outerObjects.push(leftSide);
        this.scene.add(topBar);
        this.outerObjects.push(topBar);
        break;
      case "Rechts open":
        this.scene.add(rightSide);
        this.outerObjects.push(rightSide);
        this.scene.add(leftBar);
        this.outerObjects.push(leftBar);
        this.scene.add(topPlate);
        this.outerObjects.push(topPlate);
        break;
      case "Rechts open Plafond":
        this.scene.add(rightSide);
        this.outerObjects.push(rightSide);
        this.scene.add(leftBar);
        this.outerObjects.push(leftBar);
        this.scene.add(topBar);
        this.outerObjects.push(topBar);
        break;
      case "Ingebouwd":
        this.scene.add(rightBar);
        this.outerObjects.push(rightBar);
        this.scene.add(leftBar);
        this.outerObjects.push(leftBar);
        this.scene.add(topPlate);
        this.outerObjects.push(topPlate);
        break;
      case "Ingebouwd Plafond":
        this.scene.add(rightBar);
        this.outerObjects.push(rightBar);
        this.scene.add(leftBar);
        this.outerObjects.push(leftBar);
        this.scene.add(topBar);
        this.outerObjects.push(topBar);
        break;
      default:

    }
  };

  start = () => {
    if (!this.frameId) {
      this.frameId = requestAnimationFrame(this.animate);
    }
  };

  stop = () => {
    cancelAnimationFrame(this.frameId);
  };

  animate = () => {
    this.renderScene();
    let canvas = document.getElementsByTagName("canvas")[0]
    //console.log(canvas)
    canvas.addEventListener("mousedown", this.onClick, true);
    canvas.addEventListener("mousemove", this.onHover, true)
    this.frameId = window.requestAnimationFrame(this.animate);
  };

  renderScene = () => {
    this.renderer.render(this.scene, this.camera);
  };

  onClick = (event) => {
    if (!this.props.allowPlace || this.state.activeModule === null) {
      return;
    }
    let canvasBounds = this.renderer.getContext().canvas.getBoundingClientRect();
    this.mouse.x = ((event.clientX - canvasBounds.left) / (canvasBounds.right - canvasBounds.left)) * 2 - 1;
    this.mouse.y = -((event.clientY - canvasBounds.top) / (canvasBounds.bottom - canvasBounds.top)) * 2 + 1;

    let boxOffsetX = this.closetWidth / this.slotCount / 2;
    let boxOffsetY = this.closetHeight / 2;
    this.raycaster.setFromCamera(this.mouse, this.camera);
    let intersects = this.raycaster.intersectObjects(this.scene.children);

    for (let index = 0; index < intersects.length; index++) {
      const rcObj = intersects[index];

      let slots = this.state.slots;
      if (rcObj.object.name.includes("Cslot")) {

        let slotID = parseInt(rcObj.object.name.split(" ")[1]);

        let moduleID = slotID + "_" + this.state.activeModuleData.module_name;

        let positionToPlace = rcObj.object.position;

        if (slots[slotID].isFilled) {
          let slot = slots[slotID];
          moduleID = slot.moduleID;
          slots.map(slot => {
            if (slot.moduleID === moduleID) {
              this.scene.remove(slot.moduleObj)
              slot.isFilled = false;
              slot.moduleObj = null;
              slot.moduleData = null;
              slot.moduleID = null;
            }
          })

          this.setState({ hasDoors: this.hasDoors() });
          return;
        }

        if (this.state.activeModuleData.module_size === 2) {
          if (slotID !== slots.length - 1 && slots[slotID + 1].isFilled === false) {
            slots[slotID + 1].isFilled = true;
            slots[slotID + 1].moduleID = moduleID;

            // Calculate position of module
            console.log(positionToPlace)
            let slot1Position = positionToPlace;
            let slot2Position = slots[slotID + 1].slotObj.position

            positionToPlace = new THREE.Vector3((slot1Position.x + slot2Position.x) / 2, (slot1Position.y + slot2Position.y) / 2, (slot1Position.z + slot2Position.z) / 2)

          } else return
        }

        slots[slotID].isFilled = true;
        slots[slotID].moduleID = moduleID;

        let objToPlace = this.state.activeModule.clone();

        console.log(objToPlace)

        slots[slotID].moduleObj = objToPlace;
        slots[slotID].moduleData = this.state.activeModuleData;

        let bbox = new THREE.Box3().setFromObject(objToPlace);
        objToPlace.position.set(positionToPlace.x - (bbox.max.x - bbox.min.x) / 2, positionToPlace.y + this.floorHeight - (bbox.max.y - bbox.min.y) / 2, 0);

        this.scene.add(objToPlace);


        this.placedmodels.push(objToPlace);
        // intersects[i].object.material.visible = true;
        this.props.updateSlots(slots)
        this.props.updatePrice(slots)
        // Check if door switch is set to 'open' and will place the new object to have open doors too if it has doors
        this.updateDoors(objToPlace);

        this.setState({ hasDoors: this.hasDoors() });

        break;
      }
    }
  };

  onHover = event => {
    if (!this.props.allowPlace || this.state.activeModule === null) {
      return;
    }
    let canvasBounds = this.renderer.getContext().canvas.getBoundingClientRect();
    this.mouse.x = ((event.clientX - canvasBounds.left) / (canvasBounds.right - canvasBounds.left)) * 2 - 1;
    this.mouse.y = -((event.clientY - canvasBounds.top) / (canvasBounds.bottom - canvasBounds.top)) * 2 + 1;

    let boxOffsetX = this.closetWidth / this.slotCount / 2;
    let boxOffsetY = this.closetHeight / 2;
    this.raycaster.setFromCamera(this.mouse, this.camera);
    let intersects = this.raycaster.intersectObjects(this.scene.children);

    for (let index = 0; index < intersects.length; index++) {
      const rcObj = intersects[index];

      let slots = this.state.slots;
      if (rcObj.object.name.includes("Cslot")) {

        let slotID = parseInt(rcObj.object.name.split(" ")[1]);

        slots.forEach(slot => {
          slot.slotObj.material.visible = false;
        });

        if (slots[slotID].isFilled) {
          return;
        }

        if (this.state.activeModuleData.module_size === 2) {
          if (slotID !== slots.length - 1 && slots[slotID + 1].isFilled === false)
            slots[slotID + 1].slotObj.material.visible = true;
          else return
        }

        slots[slotID].slotObj.material.visible = true;
        break;
      }
    }

  }

  clearPlacedObjects = () => {
    // console.log("Clearing placed objects");

    this.placedmodels.forEach((model) => {
      this.scene.remove(model);
    });
    this.placedmodels = []
    this.state.slots.forEach(slot => { slot.isFilled = false; slot.moduleObj = null; slot.moduleData = null; })

    this.props.updateSlots(this.state.slots)
    this.props.updatePrice(this.state.slots)

  };

  hasDoors = () => { //Check if there are doors (required to disable the switch when there are no doors)
    // console.log("Checking if has open doors");

    let doors = [];

    if (this.placedmodels != null && this.placedmodels.length > 0) {
      this.state.slots.forEach(slot => {
        if(!slot.moduleObj) { return; }
        // console.log(model)
        slot.moduleObj.children[0].children.forEach(childObject => {
          if (childObject.name.includes("DOOR")) {
            doors.push(childObject);
            //console.log(childObject);
          }
        })
      });
    }

    if (doors.length > 0) return true;

    // If door toggle set to "True" then reset to "False" (default value)
    if (this.state.doorToggle) this.toggleOpenDoors();
    return false;
  }

  updateDoors = (objToPlace) => {
    // Only update if doors are open, as by default the doors are closed
    if (this.state.doorToggle) {
      let doors = []

      // Get doors
      objToPlace.children[0].children.forEach(childObject => {
        if (childObject.name.includes("DOOR")) {
          doors.push(childObject);
        }
      });

      // If door was added update the door
      if (doors.length > 0) {
        // Copied from 'toggleOpenDoors' (Else statement of the if(this.state.doorToggle))
        let rotation = 1.5;
        doors.forEach(door => {
          let doorProps = door.name.split("_");
          let doorScale = door.scale;
          //console.log(door.parent.scale.x) 
          let matrixRef = "";
          doorProps.forEach(string => { if (string.includes("REF")) matrixRef = string.split("=")[1]; })
          let turningPoint = matrixRef.split(";").reverse()[0].replace(")", "");
          let turningWidth = matrixRef.split(";")[0];
          if (turningPoint === "-1") {
            // Deur Links
            door.rotateZ(-rotation);
          } else if (turningPoint === "1") {
            // Deur Rechts => Rotate around different point
            let bbox = new THREE.Box3().setFromObject(door);
            let transX = bbox.max.x - bbox.min.x

            if (turningWidth > 800)
              transX *= 2

            door.translateX(transX);
            door.rotateZ(rotation);
            door.translateX(-transX);
          }
          else {
            console.log("TurningPoint Not Found! ::: " + turningPoint)
          }
        })


        doors = null;
        // Update state (without changing toggle value)
        this.setState({ doorToggle: this.state.doorToggle });
      }
    }


  }

  toggleOpenDoors = () => {

    // console.log("TOGGLE OPEN DOORS VALUE OF TOGGLE");
    // console.log(this.state.doorToggle);
    let doors = [];

    this.placedmodels.forEach(model => {
      model.children[0].children.forEach(childObject => {
        if (childObject.name.includes("DOOR")) {
          doors.push(childObject);
          //console.log(childObject);
        }
      })
    });


    let rotation = 1.5;
    if (this.state.doorToggle) {
      doors.forEach(door => {
        //console.log("*** door: " + door.name);
        let doorProps = door.name.split("_");
        let doorScale = door.scale;
        //console.log(door.parent.scale.x) 
        let matrixRef = "";
        doorProps.forEach(string => { if (string.includes("REF")) matrixRef = string.split("=")[1]; })
        // console.log(door) 
        // console.log(matrixRef) 
        let turningPoint = matrixRef.split(";").reverse()[0].replace(")", "");
        let turningWidth = matrixRef.split(";")[0];
        //console.log(turningPoint)

        if (turningPoint === "-1") {
          // Deur Links
          door.rotateZ(rotation);
        } else if (turningPoint === "1") {
          // Deur Rechts => Rotate around different point
          let bbox = new THREE.Box3().setFromObject(door);
          let transX = bbox.max.z - bbox.min.z

          if (turningWidth > 800)
            transX *= 2

          door.translateX(transX);
          door.rotateZ(-rotation);
          door.translateX(-transX);
        }
        else {
          console.log("TurningPoint Not Found! ::: " + turningPoint)
        }
      })
    } else {
      doors.forEach(door => {
        //console.log("*** door: " + door.name);
        let doorProps = door.name.split("_");
        let doorScale = door.scale;
        //console.log(door.parent.scale.x) 
        let matrixRef = "";
        doorProps.forEach(string => { if (string.includes("REF")) matrixRef = string.split("=")[1]; })
        let turningPoint = matrixRef.split(";").reverse()[0].replace(")", "");
        let turningWidth = matrixRef.split(";")[0];
        if (turningPoint === "-1") {
          // Deur Links
          door.rotateZ(-rotation);
        } else if (turningPoint === "1") {
          // Deur Rechts => Rotate around different point
          let bbox = new THREE.Box3().setFromObject(door);
          let transX = bbox.max.x - bbox.min.x

          if (turningWidth > 800)
            transX *= 2

          door.translateX(transX);
          door.rotateZ(rotation);
          door.translateX(-transX);
        }
        else {
          console.log("TurningPoint Not Found! ::: " + turningPoint)
        }
      })
    }
    doors = null;
    this.setState({ doorToggle: !this.state.doorToggle })
  }

  checkIfRoomChanged = (newRoomDim) => {
    //console.log(newRoomDim)
    let shouldRedrawRoom = false;
    //if (newRoomDim.B < this.slotWidth) return false;

    Object.keys(this.currentRoomDim).forEach((key) => {
      if (this.currentRoomDim[key] !== newRoomDim[key]) shouldRedrawRoom = true;
    });
    return shouldRedrawRoom;
  };

  updateScene = () => {
    let props = this.props.closetProps;
	
    if(this.props.designstep === 1) {
      props.innerMaterial = null;
      props.outerMaterial = null;
    }

    for (var i = this.scene.children.length - 1; i >= 0; i--) {
      let obj = this.scene.children[i];
      if (obj.name.includes("wall -")) {
        obj.material.color.set(this.props.wallColor)
      }
    }

    if (this.props.designstep === 5) {
      // Set Lines invisible
      this.scene.children.forEach(obj => {
        // console.log(obj.type);
        if (obj.type === "Line") {
          obj.visible = false
        }
      })
    } else {
      // set Lines visible
      this.scene.children.forEach(obj => {
        // console.log(obj.type);
        if (obj.type === "Line") {
          obj.visible = true
        }
      })
    }

    // indien men een kast samenstelt en men gaat nadien terug om de hoogte of diepte anders in te stellen, dan moet de scale opnieuw berekend worden
    if (props.activeModule !== null && props.activeModule !== undefined && props.activeModule.module_id !== -1) {
      let activeModuleData = props.activeModule;

      //Load GLTF
      console.log("module path: " + props.activeModule.module_model_path);
      this.GLTFLoader.load(formatURL(props.activeModule.module_model_path), gltf => {
        let innerWidth = (this.currentRoomDim.B - this.currentRoomDim.AL - this.currentRoomDim.AR) / 100
        let innerHeight = (this.currentRoomDim.H - this.currentRoomDim.PO - this.currentRoomDim.PB) / 100;

        let boxSize = new THREE.Vector3();
        var box = new THREE.Box3().setFromObject(gltf.scene.children[0]);
        box.getSize(boxSize);

        let slotSize = innerWidth / this.slotCount;
        let slotScale = slotSize / (boxSize.x / props.activeModule.module_size);

        let heightScale = innerHeight / boxSize.z;

        let innerDepth = this.currentRoomDim.D / 100;
        let depthScale = innerDepth / boxSize.y;

        console.log("****************************************************************************");
        console.log('scale: x=>' + slotScale + ' y=>' + depthScale + ' z=>' + heightScale)
        console.log("****************************************************************************");

        activeModuleData.scale = { width: slotScale, depth: depthScale, height: heightScale };

      });
    }

    if (props.activeModule !== null && props.activeModule !== undefined && props.activeModule.module_id !== -1 && this.state.activeModuleData !== props.activeModule) {

      let activeModuleData = props.activeModule

      //Load GLTF
      console.log("module path: " + props.activeModule.module_model_path);
      this.GLTFLoader.load(formatURL(props.activeModule.module_model_path), gltf => {
        const root = gltf.scene;
        root.children[0].name += props.activeModule.module_name;
        root.children[0].children.forEach(mesh => {
          mesh.castShadow = true;
          mesh.receiveShadow = true;
          if (mesh.material.name.includes("Outer"))
            mesh.name = mesh.name + " (isOuter=1)"
        })

        console.log(dumpObject(root).join('\n'));
        console.log(root)

        gltf.scene.rotation.set(-0.5 * Math.PI, 0, 0);
        gltf.scene.position.set(this.currentRoomDim.AL / 100.0, this.currentRoomDim.PO / 100.0, 0)
        let innerWidth = (this.currentRoomDim.B - this.currentRoomDim.AL - this.currentRoomDim.AR) / 100
        let innerHeight = (this.currentRoomDim.H - this.currentRoomDim.PO - this.currentRoomDim.PB) / 100;

        let boxSize = new THREE.Vector3();
        var box = new THREE.Box3().setFromObject(gltf.scene.children[0]);
        box.getSize(boxSize)
        console.log(boxSize);

        let slotSize = innerWidth / this.slotCount
        let slotScale = slotSize / (boxSize.x / props.activeModule.module_size)

        let heightScale = innerHeight / boxSize.z

        let innerDepth = this.currentRoomDim.D / 100;
        let depthScale = innerDepth / boxSize.y;

        console.log("****************************************************************************");
        console.log('scale: x=>' + slotScale + ' y=>' + depthScale + ' z=>' + heightScale)
        console.log("****************************************************************************");

        activeModuleData.scale = { width: slotScale, depth: depthScale, height: heightScale }

        gltf.scene.userData.handleCoords = []
        gltf.scene.children[0].children.forEach(mesh => {
          if (mesh.name.includes("HANDGRIP")) {
            // Find Position
            mesh.name.split('(').forEach(string => {
              if (string.includes("POS")) {
                let coordString = string.replaceAll(',', '.').split("=")[1].split(")")[0];
                let coords = coordString.split(";");
                console.log(coords);
                coords[0] = coords[0] / 1000; // Width
                coords[1] = coords[1] / 1000; // Depth
                coords[2] = coords[2] / 1000; // Height
                console.log(coords);

                mesh.userData.handleCoords = coords;

                console.log(mesh);
              }

              if (string.includes("FRONTANGLE")) {
                let angleString = string.split("=")[1].split(")")[0];
                let angle = Math.PI / 180 * parseFloat(angleString);
                mesh.userData.handleAngle = angle;
              }
            })
            if (mesh.name.includes("KPWEB_GREEP_LADE")) {
              mesh.scale.set(slotScale, depthScale, heightScale);
            }
		        mesh.userData.handleScale = {x:slotScale, y:depthScale, z:heightScale};
          } 
          else {
            mesh.scale.set(slotScale, depthScale, heightScale);
          }
        })

        console.log(root.children[0].children.filter(mesh => { return mesh.name.includes("GRIP") }))

        console.log(root.children[0].children)
        root.children[0].children.filter(grip => { return grip.name.includes("GRIP") && !grip.name.includes("LADE") }).forEach(grip => {
          let gripPosition = parseFloat(grip.name.split("_").find(str => { return str.includes("POS") }).split("=")[1].split(";")[0].replace(",", "."))
          console.log(gripPosition)

          if (gripPosition < 100) {
            // Single Module Right Hinge
            try {
              let door = root.children[0].children.find(mesh => {
                //console.log("mesh.name: " + mesh.name);
                return mesh.name.includes("DOOR") && parseInt(mesh.name.split("REF=")[1].split(";")[0]) > 100 
              })
              //console.log(door);
              door.add(grip);
              }
            catch(e) {
              //console.log("*** error gripPosition < 100 ***" + e);
            }
          }
          else if (gripPosition < 600) {
            // Single Module Left Hinge OR Double Module Left Door
            try {
              let door = root.children[0].children.find(mesh => { 
                //console.log("mesh.name: " + mesh.name);
                return mesh.name.includes("DOOR") && parseInt(mesh.name.split("REF=")[1].split(";")[0]) < 100 
              })
              //console.log(door);
              door.add(grip);
              }
            catch(e) {
              //console.log("*** error gripPosition < 600 ***" + e);
            }
          }
          else if (gripPosition > 600) {
            // Double Module Right Door
            try {
              let door = root.children[0].children.find(mesh => { 
                //console.log("mesh.name: " + mesh.name);
                return mesh.name.includes("DOOR") && parseInt(mesh.name.split("REF=")[1].split(";")[0]) > 800 
              })
              //console.log(door);
              door.add(grip);
              }
            catch(e) {
              //console.log("*** error gripPosition > 600 ***" + e);
            }
          }
        })

        console.log(root.children[0].children)

        console.log(gltf.scene)
        this.setState({
          activeModule: gltf.scene,
          activeModuleData: activeModuleData,
        })

        this.props.updateLoading(false)

        //this.scene.add(gltf.scene)
      })
    } 
    else {
      this.props.updateLoading(false)
    }

    // console.log(this.scene)
    // console.log(this.props)
    // console.log(this.props.boxDimensions)
    // console.log(this.currentRoomDim)
    let shouldRedrawRoom = this.checkIfRoomChanged(this.props.boxDimensions);

    if (shouldRedrawRoom) {
      // console.log("Call Redraw");
      for (var i = this.scene.children.length - 1; i >= 0; i--) {
        let obj = this.scene.children[i];
        this.scene.remove(obj);
        //obj.dispose()
      }
      this.closetWidth = this.props.boxDimensions.B / 100.0;
      this.closetHeight = this.props.boxDimensions.H / 100.0;
      this.closetDepth = this.props.boxDimensions.D / 100.0;

      this.currentRoomDim = {
        B: this.props.boxDimensions.B,
        H: this.props.boxDimensions.H,
        D: this.props.boxDimensions.D,
        AL: this.props.boxDimensions.AL,
        AR: this.props.boxDimensions.AR,
        PB: this.props.boxDimensions.PB,
        PO: this.props.boxDimensions.PO,
      };

      // console.log(this.currentRoomDim)
      this.resetScene();
      //this.scene.children.forEach(obj => console.log(obj))
    }

    let shouldUpdateMaterials = props !== undefined && !(props.innerMaterial === this.state.innerMaterial && props.outerMaterial === this.state.outerMaterial);
    if (shouldUpdateMaterials) {
      if (props.innerMaterial !== null) {
        let texloader = new THREE.TextureLoader();
        var map = texloader.load(formatURL(props.innerMaterial.material_texture_path));
        var material = new THREE.MeshPhongMaterial({ map: map });

        this.state.slots.forEach((slot) => {
          if (slot.moduleObj !== null && slot.moduleObj !== undefined)
            slot.moduleObj.children[0].children.forEach(mesh => {
              // console.log(mesh)
              if (mesh.name.includes("PEN=5")) {
                // Features/Mounts
                return;
              }
              if (mesh.name.includes("isOuter=1")) {
                // Outer Materials
                return;
              }
              mesh.material = material
            })
        })
      }

      if (props.outerMaterial !== null) {
        let texloader = new THREE.TextureLoader();
        var map = texloader.load(formatURL(props.outerMaterial.material_texture_path));
        var material = new THREE.MeshPhongMaterial({ map: map });

        this.state.slots.forEach((slot) => {
          if (slot.moduleObj !== null && slot.moduleObj !== undefined)
            slot.moduleObj.children[0].children.forEach(mesh => {
              if (mesh.name.includes("isOuter=1")) {
                // Outer Materials
                mesh.material = material
              }
            })
        })

        this.outerObjects.forEach((obj) => {
          // console.log(obj)
          obj.material = material
        })

      }
    }

    //console.log(props)
    let shouldUpdateGrips = props !== undefined && props.activeGrip !== undefined && props.activeGrip.feature_id !== -1 && !(props.activeGrip.feature_id === this.state.activeGripData.feature_id);
    if (shouldUpdateGrips) {
      let propsActiveGripData = props.activeGrip;
      this.GLTFLoader.load(formatURL(propsActiveGripData.feature_model_path), gltf => {
        let obj = gltf.scene.children[0];
        obj.name += "REPLACEGRIP_ID=" + propsActiveGripData.feature_id;

        this.setState({
          activeGrip: obj,
          activeGripData: propsActiveGripData
        }, this.replaceGrips)
        this.props.updateLoading(false)
      })
    }
  }

  replaceGrips = () => {
    if (this.state.activeGripData.feature_id === -1) return;

    //this.scene.add(this.state.activeGrip);

    const ID = this.state.activeGrip.name.split('=')[1];

    console.warn('--- GRIPS TO REPLACE --- ID=' + ID)

    this.scene.children.forEach(sceneChild => {
      sceneChild.children.forEach(module => {
        let gripsToReplace = [];
        console.log(module.children);

        Array.from(module.children).filter(mesh => { return mesh.name.includes("DOOR") }).forEach(door => {
          Array.from(door.children).forEach(grip => {
            console.log("Door: " + grip.name);
            if (grip.name.includes("HANDGRIP")) {
               //console.log("Replace Handgrip: " + mesh.name);
               //console.log(mesh);
              gripsToReplace.push(grip);
              grip.visible = false;
            }

            if (grip.name.includes("REPLACEGRIP")) {
              console.log("Remove Grip: " + grip.name);
              door.remove(grip);
            }
          })
        })

        Array.from(module.children).filter(mesh => { return mesh.name.includes("GRIP") }).forEach(grip => {

          console.log("Grip: " + grip.name)
          if (grip.name.includes("HANDGRIP")) {
            //console.log("Replace Handgrip: " + mesh.name);
            //console.log(mesh);
            gripsToReplace.push(grip);
            grip.visible = false;
          }

          if (grip.name.includes("REPLACEGRIP")) {
            console.log("Remove Grip: " + grip.name);
            module.remove(grip);
          }

        })

        console.log(gripsToReplace)
        let index = 0;
        gripsToReplace.forEach(mesh => {
          let door = mesh.parent;
          let featureName = this.state.activeGripData.feature_name;
          console.log("gripstoreplace: " + door.name);
          console.log("feature name: " + this.state.activeGripData.feature_name);

          let objToPlace = this.state.activeGrip.clone();
          objToPlace.userData.handleCoords = mesh.userData.handleCoords;
          objToPlace.name += "_key=" + index;

          let gripOffset = 0;

          if (mesh.name.includes("KPWEB_GREEP_LADE")) {
            let bbox = new THREE.Box3().setFromObject(objToPlace);
            gripOffset = (bbox.max.x - bbox.min.x) / 2;

			      mesh.scale.set(mesh.userData.handleScale.x, mesh.userData.handleScale.y, mesh.userData.handleScale.z);
            if(featureName.includes("TOP")) {
              objToPlace.position.set(mesh.userData.handleCoords[0]*mesh.userData.handleScale.x, mesh.userData.handleCoords[1]*mesh.userData.handleScale.y, mesh.userData.handleCoords[2]*mesh.userData.handleScale.z);
            }
            else {
              if(door.name.includes("B120")) {
                objToPlace.position.set(mesh.userData.handleCoords[0]*0.84, mesh.userData.handleCoords[1]*mesh.userData.handleScale.y, mesh.userData.handleCoords[2]*mesh.userData.handleScale.z);
              }
              else {
                if(door.name.includes("RECH")) {
                  objToPlace.position.set(mesh.userData.handleCoords[0]*1.2, mesh.userData.handleCoords[1]*mesh.userData.handleScale.y, mesh.userData.handleCoords[2]*mesh.userData.handleScale.z);
                }
                else {
                  objToPlace.position.set(mesh.userData.handleCoords[0]*0.68, mesh.userData.handleCoords[1]*mesh.userData.handleScale.y, mesh.userData.handleCoords[2]*mesh.userData.handleScale.z);
                }
              }
            }
			      objToPlace.rotation.y = -mesh.userData.handleAngle;
          } 
          else {
			      objToPlace.position.set(mesh.userData.handleCoords[0], mesh.userData.handleCoords[1], mesh.userData.handleCoords[2]);
			      objToPlace.rotation.y = -mesh.userData.handleAngle;
		  }

          
          //console.log(objToPlace)
          door.add(objToPlace);
          index++;
        })
        console.log(this.scene)
      })
    })


  }

  render() {
    // console.log("DESIGN STEP");
    // console.log(this.props.designstep);

    return (
      <div>
        <div
          className="scene-actions"
          ref={(mount) => {
            this.mount = mount;
          }}>

        </div>
        <div style={{ textAlign: "center", paddingTop: "30px" }}>
          <IconButton hasObjects={this.placedmodels != null && this.placedmodels.length > 0 && this.props.designstep < 5} clearPlacedObjects={this.clearPlacedObjects} />
          <Switch hasDoors={this.state.hasDoors} isOpen={this.state.doorToggle} toggleOpenDoors={this.toggleOpenDoors} />
        </div>
        <div style={{ textAlign: "center" }}>
          <ButtonGroup id="renderer-camera-buttons" style={{ marginTop: (this.canvasHeight - 140) + "px" }} aria-label="Basic example">
            <Button onClick={() => { this.setCameraAngle("left") }}>Links</Button>
            <Button onClick={() => { this.setCameraAngle("center") }}>Gecentreerd</Button>
            <Button onClick={() => { this.setCameraAngle("right") }}>Rechts</Button>
          </ButtonGroup>
        </div>

      </div>

    );
  }
}

function getSlotCount(dim, slotWidth) {
  //console.log(dim)
  let innerDimension = dim.B - dim.AL - dim.AR;

  if (innerDimension < slotWidth) {
    return 1
  } else {
    console.log(innerDimension / slotWidth)
    let slotCount = Math.trunc(innerDimension / slotWidth) + 1
    console.log("slotCount: " + slotCount + "  ---   slotWidth: " + innerDimension / slotCount);
    return slotCount
    // return Math.trunc(innerDimension / slotWidth);
  }

}